/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import "bootstrap/js/src/util";
import "bootstrap/js/src/alert";
import "bootstrap/js/src/button";
import "bootstrap/js/src/collapse";
import "bootstrap/js/src/dropdown";
import "bootstrap/js/src/modal";
import "bootstrap/js/src/popover";
import "bootstrap/js/src/tab";
import "bootstrap/js/src/toast";
import "bootstrap/js/src/tooltip";
import "bootstrap-touchspin";
import "./lib/jquery.hoverIntent.min";
import "jquery-nice-select";
import SwiperSlider from "./components/SwiperSlider";
import "./components/responsive";
import "./components/customer";
import "./components/listing";
import "./components/cart";
import Form from "./components/form";
import MobileMenu from "./components/mobile-menu";
import InfoBar from "./components/InfoBar";
import prestashop from "prestashop";
import EventEmitter from "events";
import "./components/block-cart";
import lazysizes from "lazysizes";
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}
$(document).ready(() => {
  const form = new Form();
  const swiperSlider = new SwiperSlider();
  const mobileMenu = new MobileMenu();
  const infoBar = new InfoBar();
  initScrollShadow();
  initNiceSelect();
  initHomeBannerSlider();
  form.init();
  infoBar.init();
  swiperSlider.init("#carousel");
  swiperSlider.init(".products-slider", {
    slidesPerView: "auto",
    freeRide: true,
    breakpoints: {
      768: {
        slidesPerView: 2
      }
    }
  });
  mobileMenu.init();
  $(".custom-file-input").on("change", function() {
    let fileName = $(this).val().split("\\").pop();
    $(this).next(".custom-file-label").addClass("selected").html(fileName);
  });
});
document.addEventListener("lazyloaded", function(e) {
  $(e.target).parent().addClass("rc--lazyload");
});
function initScrollShadow() {
  const $scrollElements = $(".js-scroll-shadow");
  $scrollElements.each((i, el) => {
    const $el = $(el);
    const offset = 20;
    const theme = $el.data("theme");
    const $wrapper = $("<div>").addClass("js-scroll-shadow-wrapper");
    theme && $wrapper.addClass(`js-scroll-shadow-wrapper-theme-${theme}`);
    $el.wrap($wrapper);
    $el.on("scroll", (e) => {
      const $target = $(e.target);
      const $wrapper2 = $target.closest(".js-scroll-shadow-wrapper");
      const width = $target.width();
      const scrollWidth = e.target.scrollWidth;
      const scrollLeft = e.target.scrollLeft;
      const scrollRight = width + scrollLeft;
      if (scrollLeft - offset > 0) {
        $wrapper2.addClass("js-scroll-shadow-left");
      } else if (scrollLeft == 0) {
        $wrapper2.removeClass("js-scroll-shadow-left");
      }
      if (scrollRight + offset < scrollWidth) {
        $wrapper2.addClass("js-scroll-shadow-right");
      } else if (scrollWidth == scrollRight) {
        $wrapper2.removeClass("js-scroll-shadow-right");
      }
    });
    $el.trigger("scroll");
  });
}
function initNiceSelect() {
  $("select:not(.niceselect-ignore)").niceSelect();
}
function initHomeBannerSlider() {
  const swiperSlider = new SwiperSlider();
  if ($(window).innerWidth() >= 768) {
    swiperSlider.init(".home-banners-slider");
  }
}
if (module.hot) { module.hot.accept(); }